<script>
  import { onMount } from "svelte"
  export let headerBackground
  export let colorCount
  export let showContainer = false
  export let column = 5
  import { getEquallySpacedColors } from "../../../../../../Script/colors"
  import { loadJs, loadCSS } from "../../../../../../Script/loadLibrary"

  /**
   * @type {Array} list of theme colors
   */
  let themeColors = ["#232428", "#fee2e2", "#fef08a", "#c4b5fd", "#fecdd3"]

  /**
   * @type {Array} list of standard colors
   */
  let standardColors = []

  /**
   * @type {Number} Width of the individual color box
   */
  let width

  /**
   * @type {HTMLElement} binded the overall palette container
   */
  let container

  let showModulePalette = false

  export let customColors = []

  // let fixedWidth
  // let sharedWidth
  onMount(async () => {
    if (window.innerWidth < 500) {
      showModulePalette = true
      // Load pickr library if it's not already loaded
      if (!document.querySelector("#pickr")) await loadJs("jszip", "assets/lib/pickr.min.js")
      if (!document.querySelector("#pickrCSS")) await loadCSS("pickrCSS", "assets/lib/nano.min.css")

      const inputElement = document.querySelector(".pickr")

      const pickr = new Pickr({
        el: inputElement,
        useAsButton: true,
        default: "#42445A",
        theme: "nano",

        components: {
          preview: true,
          opacity: true,
          hue: true,
        },
      })
        .on("init", (pickr) => {})
        .on("show", (color, instance) => {
          showContainer = true
        })
        .on("change", (color, source, instance) => {
          headerBackground = color.toRGBA().toString(0)
        })
        .on("hide", (instance) => {
          showContainer = false
          addCustomColor()
        })
    }

    // if (window.innerWidth > 1280) fixedWidth = 49.6
    // else if (window.innerWidth > 1024) fixedWidth = 45
    // else if (window.innerWidth > 768) fixedWidth = 40
    // else if (window.innerWidth > 640) fixedWidth = 35
    // else fixedWidth = 30

    // sharedWidth = container.clientWidth / (fixedWidth * 7)
    // width = fixedWidth + sharedWidth

    let fetchedColors = getEquallySpacedColors(colorCount)

    standardColors = ["#000000", "#ffffff", ...fetchedColors]
  })

  /**
   * @description function for adding the new selected standard color
   * @param e targetting binded value to add the color to the existing array
   */
  const addCustomColor = () => {
    // eliminating first element from the standardColors
    if (customColors.length >= 4) customColors.shift()

    //new element added to the array
    customColors = [...customColors, headerBackground]
  }
</script>

<h1 class="py-3 text-base font-medium text-[#868484] dark:text-slate-200">Standard Colors</h1>
<div class="grid gap-2" style="grid-template-columns: repeat({column}, 1fr)">
  <button
    type="button"
    on:click={() => {
      headerBackground = "transparent"
    }}
    class="flex h-[28.8px] w-12 {headerBackground == 'transparent' ? 'ring-1 ring-extraBlue-500' : ''} items-center justify-center rounded-[3px] bg-gray-500 outline-none hover:scale-110"
  >
    <i class="fa-solid fa-droplet-slash fa-lg text-white" />
  </button>

  {#each standardColors as color}
    <button
      type="button"
      on:click={() => {
        headerBackground = color
      }}
      class="h-[28.8px] rounded-[3px] {color == headerBackground ? 'ring-1 ring-extraBlue-500' : ''} hover:scale-110 hover:shadow-colorShadow"
      style="background-color:{color}"
    />
  {/each}
</div>

<h1 class="py-3 text-base font-medium text-[#868484] dark:text-slate-200">Custom Colors</h1>

<div class="grid gap-2" style="grid-template-columns: repeat({column}, 1fr)">
  {#each customColors as color}
    <button
      type="button"
      on:click={() => {
        headerBackground = color
      }}
      class="h-[28.8px] rounded-[3px] {color == headerBackground ? 'ring-1 ring-extraBlue-500' : ''} hover:scale-110 hover:shadow-colorShadow"
      style="background-color:{color}"
    />
  {/each}
  <div class="relative flex h-[28.8px] w-[52.4px] items-center justify-center pr-0.5">
    {#if showModulePalette}
      <div class="pickr flex h-full w-[52.4px] items-center justify-center rounded-[3px] border border-[#a0a1a580] bg-transparent">
        <i class="fa-solid fa-plus text-gray-200" />
      </div>
    {:else}
      <div class="flex h-full w-[52.4px] items-center justify-center rounded-[3px] border border-[#a0a1a580] bg-transparent">
        <i class="fa-solid fa-plus text-gray-200" />
      </div>
      <input
        on:input={(e) => {
          headerBackground = e.target.value
        }}
        on:change={(e) => {
          headerBackground = e.target.value
          addCustomColor()
        }}
        type="color"
        class="absolute inset-0 h-full cursor-pointer opacity-0"
      />
    {/if}
  </div>
</div>
